import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

import Footer from './Footer';
import List from './PopoverList';
import InstructionsParagraph from './Instructions';

const Container = styled.div`
    width: ${({ isEmpty }) => isEmpty ? '590px' : '94vw' };
    max-width: 1208px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    white-space: normal;
`;

const Header = styled.header`
    padding: 13px 18px 18px;
`;

const Title = styled.h2`
    margin-bottom: 3px;
    font-family: ${FONTS.primaryFont};
    font-size: 18px;
    color: ${COLORS.mlbWhite};
`;

const Instructions = styled(InstructionsParagraph)`
    font-size: 14px;
    line-height: 1.8;
`;

export const Clips = styled.div`
    position: relative;
    flex: 1;

    &:before {
        content: '${({ placeholderText, isEmpty }) => isEmpty && placeholderText}';
        flex: 1;
        display: flex;
        align-items: center;
        position: absolute;
        box-sizing: border-box;
        top: 25px;
        width: 100%;
        height: 80px;
        padding: 18px;
        font-size: 15px;
        color: ${COLORS.mlbGrey2};
        background:
            linear-gradient(to right, ${COLORS.mlbGrey7} 50%, ${COLORS.mlbGrey6} 0%) top/14px 1px repeat-x, /* top */
            linear-gradient(to right, ${COLORS.mlbGrey7} 50%, ${COLORS.mlbGrey6} 0%) bottom/14px 1px repeat-x; /* bottom */
    }
`;

const Content = (props) => {

    const {
        config,
        dictionary,
        reel,
        clipsLoading,
        clipsData,
        lang,
        removeClip,
        reorder,
        openReelCreationModal,
        openClipTrimming,
        isLoggedIn,
        userId,
        closeReelCreation,
    } = props;

    const isEmpty = !reel?.reelClips?.length;

    /** Keep the onMount isEmpty value */
    const isEmptyOnMount = useRef(isEmpty);

    return (
        <Container isEmpty={isEmptyOnMount.current}>
            <Header>
                <Title>{_get(dictionary, 'create_reel_title', 'Create Your Own Reel')}</Title>
                <Instructions isEmpty={isEmpty} config={config} dictionary={dictionary}/>
            </Header>
            <Clips
                placeholderText={_get(dictionary, 'create_reel_empty_msg', 'To get started, add one or more highlights to your custom reel.')}
                isEmpty={isEmpty}
            >
                <List
                    config={config}
                    reel={reel}
                    clipsLoading={clipsLoading}
                    clipsData={clipsData}
                    lang={lang}
                    openClipTrimming={openClipTrimming}
                    removeClip={removeClip}
                    reorder={reorder}
                    dictionary={dictionary}
                />
            </Clips>
            <Footer
                config={config}
                dictionary={dictionary}
                reel={reel}
                openReelCreationModal={openReelCreationModal}
                isLoggedIn={isLoggedIn}
                userId={userId}
                closeReelCreation={closeReelCreation}
            />
        </Container>
    );

};

Content.propTypes = {
    config: PropTypes.object.isRequired,
    dictionary: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    openReelCreationModal: PropTypes.func.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
    reel: PropTypes.object.isRequired,
    clipsLoading: PropTypes.bool.isRequired,
    clipsData: PropTypes.array.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
};

export default Content;
